let toastInstance = null;

export function setToastInstance(instance) {
  toastInstance = instance;
}

export function notifySuccess(summary, detail = "") {
  toastInstance?.add({ severity: "success", summary, detail, life: 3000 });
}

export function notifyError(summary, detail = "") {
  toastInstance?.add({ severity: "error", summary, detail, life: 4000 });
}

export function notifyWarn(summary, detail = "") {
  toastInstance?.add({ severity: "warn", summary, detail, life: 4000 });
}

export function notifyInfo(summary, detail = "") {
  toastInstance?.add({ severity: "info", summary, detail, life: 3000 });
}

export function notifyContrast(summary, detail){
    toastInstance?.add({ severity: "contrast", summary, detail, life: 4000 });
}

export function clearToasts() {
    if (!toastInstance) return;
    if (typeof toastInstance.onRemoveAllGroups === "function") {
        toastInstance.onRemoveAllGroups();
    } else if (typeof toastInstance.removeAllGroups === "function") {
        toastInstance.removeAllGroups();
    } else if (Array.isArray(toastInstance.messages)) {
        toastInstance.messages = [];
    }
}